<script>
  import {
    onMount,
    onDestroy
  } from "svelte";
  import { SPRITES, TYPE_SPRITE_MAP } from "../../constants/sprites";
  import { SetupStore } from "../stores/gameStore";
  import ComponentTiled from "./ComponentTiled.svelte";
  import { getTextsActions } from "../../constants/allTexts";

  export let type, width, color, onclick, disabled;

  const textTurnorderPosition = _('Turn order position');
  const textsActions = getTextsActions();

  $: ab = $SetupStore.data.actionTokens[type];

  let tooltipID = ''.concat(type,'_actionSelection');
  if (color) {
    tooltipID = ''.concat(type,'_', color.replace("#", ""), '_turnorder');
  }
  let tooltipCreated = false;
  let delayTimeout;

  onMount(() => {
    if (type != "HIDDEN") {
      if (delayTimeout) {
        clearTimeout(delayTimeout);
      }
      delayTimeout = setTimeout(() => {
        createTooltips();
      }, 50);
    }
  });

  let trackChanges = type;

  $: if (trackChanges != type) {
    trackChanges = type;
    tooltipID = ''.concat(type,'_actionSelection');
    if (color) {
      tooltipID = ''.concat(type,'_', color.replace("#", ""), '_turnorder');
    }
    if (type != "HIDDEN") {
      if (delayTimeout) {
        clearTimeout(delayTimeout);
      }
      delayTimeout = setTimeout(() => {
        createTooltips();
      }, 50);
    }
  }

  function createTooltips () {
    tooltipCreated = true;
    const actionData = $SetupStore?.data?.actionTokens?.[type];
    window.GAME.addTooltipHtml(
      tooltipID,
      `<div style="display:flex; flex-direction:column; max-width: 450px; word-wrap: break-word;">
        <div style="width:100%;display:flex;justify-content:space-between;align-items:center; gap:2rem;">
          <div class="headline">
            ${textsActions[type].name}
          </div>
        </div>
        <hr style="width:100%;"/>
        ${Object.values(textsActions[type].description).map((desc) => `<p>${desc}</p>`).join("")}
        <hr style="width:100%;"/>
        ${textTurnorderPosition}: ${actionData.turnorder}
      </div>`
    );
  }

  onDestroy(() => {
    // Cleanup the tooltip
    if (tooltipCreated === true) {
      window.GAME.removeTooltip(tooltipID)
    }
  });
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="{!!onclick ? 'hover' : ''} wrapper"
  id = {tooltipID}
  on:click={onclick}
  class:disabled
>
  <!-- {JSON.stringify(type)} -->
  {#if color}
    <div class="color" style:background-color={color}></div>
  {/if}
  <ComponentTiled
    {width}
    sprite={SPRITES[TYPE_SPRITE_MAP["ACTIONS"]]}
    offset={color ? [0, 0] : [0, 1]}
    borderRadius={2}
    className="atbg shadow-sm"
  />

  <ComponentTiled
    {width}
    sprite={SPRITES[TYPE_SPRITE_MAP["ACTIONS"]]}
    offset={ab?.offset || [0, 0]}
    className="aticon"
  />
</div>

<style>
  .wrapper {
    position: relative;
  }
  .color {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50%;
    mix-blend-mode: multiply;
  }
  :global(.atbg) {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .disabled {
    opacity: 0.2;
    pointer-events: none;
  }
  :global(.aticon) {
    z-index: 10;
    transform: scale(0.8);
  }
</style>
